
import React from 'react';
const Pin2Icon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 20 20"
        {...props}
    >
        <path d="M7.91667 12.0833L2.5 17.5M4.16667 7.90416L11.8275 15.565L13.2417 14.1508L12.9142 10.995L17.5058 7.10083L12.6308 2.22583L8.73583 6.8175L5.58083 6.49L4.16667 7.90416Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />

    </svg>

);

export default Pin2Icon;


